/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeTemplateCreateCtrl
 */
angular.module('mercury.modules.stock.stocktaketemplate')
.controller('StockStocktakeTemplateCreateCtrl', ["dialog", "$q", "$scope", "$state", "StocktakeTemplates", "StockItemSuperGroups", function(dialog, $q, $scope, $state, StocktakeTemplates, StockItemSuperGroups) {
  $scope.userTemplate = StocktakeTemplates.getAllActive();
  $scope.systemTemplates = StockItemSuperGroups.getAll();

  $scope.create = function(params) {
    StocktakeTemplates.create(params)
    .then(function() {
      $state.go('Stock.StocktakeTemplates', {}, {reload: true});
    });
  };
}]);
